import React from 'react';
import { Alert, Button } from 'antd';
import { possibleDuplicatesOf } from './workflowFourPhaseSUtils';

/**
 * S3b fix9 — «Có thể trùng với…»: đạo cụ BE giữ riêng (có câu nguồn riêng) nhưng có thể cùng một vật với hàng đã có.
 * Chỉ nhắc, KHÔNG chặn duyệt cổng; gộp thật là thao tác tay ở tab Tài sản. Mục còn là cờ dò thiếu thì có nút mở hộp xử lý sẵn có.
 * Mảng rỗng / vắng ⇒ không hiện gì.
 */
export const PossibleDuplicates: React.FC<{
  status: Parameters<typeof possibleDuplicatesOf>[0];
  busy?: boolean;
  onResolve?: (findingId: string) => void;
}> = ({ status, busy = false, onResolve }) => {
  const items = possibleDuplicatesOf(status);
  if (!items.length) return null;
  return <div data-testid="possible-duplicates"><Alert className="wf4-banner" type="info" showIcon style={{ margin: '8px 0' }}
    message={`${items.length} đạo cụ có thể trùng với vật đã có — không chặn duyệt`}
    description={<ul className="wf4-flag-items" style={{ margin: 0 }}>{items.map((item) => <li key={item.key} data-testid="possible-duplicate">
      <div className="wf4-flag-item-main"><b>{item.propName}</b> — {item.reason}</div>
      {item.canResolve && item.findingId && onResolve && <span className="wf4-flag-item-actions"><Button size="small" disabled={busy} onClick={() => onResolve(item.findingId!)}>Xử lý mục này</Button></span>}
    </li>)}</ul>} /></div>;
};
